
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievance-policy",
      function () {
        return require("private-next-pages/grievance-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grievance-policy"])
      });
    }
  